import { DashboardFilled } from '@ant-design/icons'
import { Badge } from 'antd'
import classNames from 'classnames'
import { useIntl } from 'react-intl'

import { ExternalLinkOutlined } from '@/components/ui/icons'
import { useHttpFetcher } from '@/utils/http'
import { buildI18nFunction } from '@/utils/messages'

import styles from './StatusLink.module.css'

type Page = {
  id: string
  name: string
  url: string
  time_zone: string
  updated_at: string
}

type Status = {
  indicator: string
  description: string
}

type PageStatus = {
  page: Page
  status: Status
}

export function StatusLink(): JSX.Element {
  const t = buildI18nFunction(useIntl().formatMessage)
  const { data, isLoading, error } = useHttpFetcher<PageStatus>({
    url: 'https://status.clayton.io/api/v2/status.json',
  })
  if (error || !data) return null
  const status = getStatus(isLoading ? 'loading' : data.status?.indicator)
  return (
    <a
      className={styles['icon-badge']}
      data-cy="status-link"
      href="https://status.clayton.io"
      rel="noreferrer"
      target="_blank"
    >
      <Badge
        data-cy="status-link-badge"
        dot
        className={classNames(['anticon', styles[`status-${status}`]])}
      >
        <DashboardFilled />
      </Badge>
      <span className="menu-item-title">
        {t('SiderMenu.status')} <ExternalLinkOutlined />
      </span>
    </a>
  )
}

function getStatus(indicator: string) {
  switch (indicator) {
    case 'none':
      return 'success'
    case 'critical':
      return 'error'
    case 'loading':
      return 'processing'
    default:
      return 'warning'
  }
}
